import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { RBAC_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PermissionsSetupPage } from '@/features/roles/pages/PermissionsSetupPage';

const searchSchema = z.object({
  userId: z.number().optional(),
});

export const Route = createFileRoute('/_auth/users/permissions')({
  validateSearch: searchSchema,
  beforeLoad: ({ search }) =>
    requirePermission(
      search.userId === undefined
        ? RBAC_PERMISSIONS.ROLE_PERMISSION_EDIT
        : RBAC_PERMISSIONS.USER_PERMISSION_EDIT,
    ),
  component: function PermissionsRoute() {
    const { userId } = Route.useSearch();
    return (
      <ErrorBoundary moduleName="Permissions">
        <Suspense fallback={<PageLoader />}>
          <PermissionsSetupPage userId={userId} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
